define("PDPBanner.SS2Model",
[
    "Backbone",
    "Utils"
],
function(
    Backbone,
    Utils
){
    "use strict";

    return Backbone.Model.extend({
        
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/PDPBanner/SuiteScript2/PDPBanner.Service.ss"
            ),
            true
        )
    });
});
